import React from 'react'
import GetManagementStatus from './MyMapUtils/GetManagementStatus';

export default function ResultTrafficRegulation(props) {

    return (
        <table className="Result_table" style={{ height: props.ResultHeight + 'px' }}>
            <thead>
                <tr style={{paddingRight:"6px",border:"none",height:"50px"}}>
                    <th className="Result_checkBox">
                        <input type="checkbox" id="allCheck" style={{margin:"0"}}
                            onClick={(e)=>props.onChangeRemoveAllCheck(e,props.items.map(item=>item.id))}
                            disabled={props.isUpdate}/>
                    </th>
                    <th className="Result_items Result_items_col1">
                        <div>申請日</div>
                    </th>
                    <th className="Result_items Result_items_col2">
                        <div>規制期間（開始）</div>
                        <div>規制期間（終了）</div>
                    </th>
                    <th className="Result_items Result_items_col3">
                        <div>申請の状態</div>
                    </th>
                    <th className="Result_items Result_items_col4">
                        <div>最終更新日時</div>
                    </th>
                </tr>
            </thead>
            <tbody style={{ height: (props.ResultHeight - 50) + 'px' }}>
                {props.items && props.items.map(item =>
                    <tr className={"Result_row" + (props.selectedItem != null && props.selectedItem?.id === item.id ? " Result_row_active":"") + (props.oldSelectedItem != null && props.oldSelectedItem?.id === item.id ? " Result_row_focus":"")}
                        onClick={(e)=>!props.isUpdate ? props.onChangeSelectedRowAndEditClear(item,e,true,false):null}
                        onMouseEnter={() =>!props.isUpdate ? props.onEnterItem(item):null }  
                        onMouseLeave={() =>!props.isUpdate ? props.onLeaveItem(item):null }
                        key={item.id}
                        id={item.id}>
                        <td className="Result_checkBox" onClick={(e)=>props.onChangeRemoveCheck(e,item.id)}>
                            <input type="checkbox" id="checkbox1" className="Result_checkBox_box" 
                                onClick={(e)=>props.onChangeRemoveCheck(e,item.id)}
                                disabled={props.isUpdate}/>
                        </td>
                        <td className="Result_items Result_items_col1">
                            <div className="Result_item" style={{wordBreak: "break-all",wordWrap: "break-word",textAlign:"left" }} >
                                {item.applicationDate}
                            </div>
                        </td>
                        <td className="Result_items Result_items_col2">
                            <div className="Result_item" >{item.restrictedStartDateTime}</div>
                            <div className="Result_item" >{item.restrictedEndDateTime}</div>
                        </td>
                        <td className="Result_items Result_items_col3">
                            <div className="Result_item" >{GetManagementStatus("applicationStatus",item?.applicationStatus,"name")}</div>
                        </td>
                        <td className="Result_items Result_items_col4">
                            <div className="Result_item" >{item.modifiedDateTime}</div>
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
    );
}
